import { UpcomingMatchesThreshold } from "components/Matches/UpcomingMatchesThreshold";
import { CompactRecentMatches } from "components/Matches/Compact/CompactRecentMatches";
import { Column, GrowColumn } from "pages/styles";
import { daysToMs } from "TimeHelper";
import { COMPACT_COL_WIDTH } from "theme";
import { Panel } from "components/Panel/Panel";
import { CompactUpcomingTournaments } from "components/Tournaments/Compact/CompactUpcomingTournaments";
import { MultiColumnPage } from "pages/PageTemplates";
import { CompactUpcomingTours } from "components/Tours/Compact/CompactUpcomingTours";

const UPCOMING_TOURNAMENTS_AMOUNT = 4;
const RECENT_MATCHES_AMOUNT = 8;
const UPCOMING_GAME_THRESHOLD = daysToMs(31);

export const HomePage = () => {
  return (
    <MultiColumnPage>
      {/* Disabled with loading changes */}
      {/* <Column
            style={{ minWidth: COMPACT_COL_WIDTH, maxWidth: COMPACT_COL_WIDTH }}
            hideUnderWidth={950}
          >
            {/* Disabled since the rankings are wrong */}
      {/* <Panel header="Worlds Ranking">
              <CompactFinalRankingsTable
                tournamentId={"2023TmwtWcWorlds"} // todo - hardcoded bad
              />
            </Panel> */}
      {/*            
             <Panel header="Ranking TMGL">
              <CompactTournamentTable
                tournamentId={"2023TmwtStage2Tmgl"} // todo - hardcoded bad
              />
            </Panel>
            <Panel header="Ranking TMCL">
              <CompactTournamentTable
                tournamentId={"2023TmwtStage2Tmcl"} // todo - hardcoded bad
              />
            </Panel>
          </Column> */}
      <GrowColumn>
        <UpcomingMatchesThreshold
          threshold={UPCOMING_GAME_THRESHOLD}
          showTrackScores={false}
        />
      </GrowColumn>
      {/* todo style? */}
      <Column
        style={{ minWidth: COMPACT_COL_WIDTH, maxWidth: COMPACT_COL_WIDTH }}
        hideUnderWidth={1175}
      >
        <Panel header="Recent Matches">
          <CompactRecentMatches amount={RECENT_MATCHES_AMOUNT} />
        </Panel>
        <Panel header="Ongoing / Upcoming Tours">
          <CompactUpcomingTours amount={UPCOMING_TOURNAMENTS_AMOUNT} />
        </Panel>
        <Panel header="Ongoing / Upcoming Tournaments">
          <CompactUpcomingTournaments amount={UPCOMING_TOURNAMENTS_AMOUNT} />
        </Panel>
      </Column>
    </MultiColumnPage>
  );
};
